import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoginTab from './LoginTab';
import RegisterTab from './RegisterTab';
import {
    authTabSx,
    authTabsContainerSx,
    authTitleSx,
} from './authDialogStyles';

const AuthForm = ({
    initialTab = 'login',
    onLogin,
    onRegister,
    loading,
    apiError,
    onClearApiError,
    captchaEnabled = true,
    showTitle = true,
    onTabChange,
}) => {
    const { t } = useTranslation();
    const [tab, setTab] = useState(initialTab);

    useEffect(() => {
        setTab(initialTab);
    }, [initialTab]);

    const handleTabChange = (nextTab) => {
        setTab(nextTab);
        onTabChange?.(nextTab);
        onClearApiError?.();
    };

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {showTitle && (
                <Typography sx={authTitleSx}>
                    {tab === 'register' ? t('Регистрация') : t('Авторизация')}
                </Typography>
            )}

            <Box sx={authTabsContainerSx}>
                <Box
                    component='button'
                    type='button'
                    onClick={() => handleTabChange('login')}
                    sx={authTabSx(tab === 'login')}
                >
                    {t('Авторизация')}
                </Box>
                <Box
                    component='button'
                    type='button'
                    onClick={() => handleTabChange('register')}
                    sx={authTabSx(tab === 'register')}
                >
                    {t('Регистрация')}
                </Box>
            </Box>

            {tab === 'login' ? (
                <LoginTab
                    onSubmit={onLogin}
                    loading={loading}
                    apiError={apiError}
                    onClearApiError={onClearApiError}
                    captchaEnabled={captchaEnabled}
                />
            ) : (
                <RegisterTab
                    onSubmit={onRegister}
                    loading={loading}
                    apiError={apiError}
                    onClearApiError={onClearApiError}
                    captchaEnabled={captchaEnabled}
                />
            )}
        </Box>
    );
};

export default AuthForm;
